export default "__VITE_ASSET__C85y9ATI__"